<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.name"
        allowClear
        placeholder="物品名称"
        @keyup.enter.native="serch_get_lis"
      />
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.purchaseCode"
        allowClear
        placeholder="申请单号"
        @keyup.enter.native="serch_get_lis"
      />
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.createBy"
        allowClear
        placeholder="申请人"
        @keyup.enter.native="serch_get_lis"
      />
      <a-select
        show-search
        allowClear
        placeholder="公司名称"
        class="margin_self"
        @change="handlecompany"
        v-model="serchInfo.company_id"
        @keyup.enter.native="serch_get_lis"
        style="width: 120px"
      >
        <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
          {{ item.title }}
        </a-select-option>
      </a-select>
      <a-tree-select
        allowClear
        :treeData="deptTree"
        v-model="serchInfo.deptId"
        :disabled="!serchInfo.company_id"
        placeholder="部门名称"
        @keyup.enter.native="serch_get_lis"
        class="margin_self"
        style="width: 120px"
        treeDefaultExpandAll
      >
      </a-tree-select>
      <!-- <a-select show-search allowClear v-model="serchInfo.deptId" :disabled="!serchInfo.company_id" placeholder="部门名称" @keyup.enter.native="serch_get_lis"
			 class="margin_self" style="width: 120px">
				<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
					{{ item.dept_name }}
				</a-select-option>
			</a-select> -->
      <a-range-picker
        v-model="serchInfo.createTimelist"
        valueFormat="YYYY-MM-DD"
        :placeholder="['申请开始', '申请结束']"
        style="width: 230px; margin-right: 10px"
        @keyup.enter.native="serch_get_lis"
      />
      <a-select
        allowClear
        v-model="serchInfo.buStatus"
        placeholder="审批状态"
        class="margin_self"
        style="width: 120px"
        @keyup.enter.native="serch_get_lis"
      >
        <a-select-option :value="index" v-for="(item, index) in applyExamineStatus" :key="index">
          {{ item }}
        </a-select-option>
      </a-select>
      <a-select
        allowClear
        v-model="serchInfo.status"
        placeholder="采购状态"
        class="margin_self"
        style="width: 120px"
        @keyup.enter.native="serch_get_lis"
      >
        <a-select-option :value="index" v-for="(item, index) in applyStatus" :key="index">
          {{ item }}
        </a-select-option>
      </a-select>
      <a-button type="primary" @click="serch_get_lis"> 查询 </a-button>
      <a-button type="primary" @click="reset"> 重置 </a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table
        :data-source="lis"
        bordered
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
      >
        <a-table-column key="index" title="序号" data-index="index" width="70px">
          <template scope="text, record, index">{{
            (pagination.current - 1) * pagination.pageSize + index + 1
          }}</template>
        </a-table-column>
        <a-table-column
          key="purchaseCode"
          title="采购申请单号"
          ellipsis="true"
          width="220px"
          data-index="purchaseCode"
        />
        <a-table-column key="itemType" title="资产分类" data-index="itemType">
          <template scope="text">{{ goodsTypeObj[text] }}</template>
        </a-table-column>
        <a-table-column key="model" title="规格型号" ellipsis="true" data-index="model" />
        <a-table-column key="name" title="物品名称" ellipsis="true" data-index="name" />
        <a-table-column key="averageQuote" title="供应商报价均价" ellipsis="true" data-index="averageQuote" />
        <a-table-column key="singlePrice" title="采购价" ellipsis="true" data-index="singlePrice" />
        <a-table-column key="companyName" title="采购申请公司" ellipsis="true" data-index="companyName" />
        <a-table-column key="deptName" title="采购申请部门" ellipsis="true" data-index="deptName" />
        <a-table-column key="createByName" title="采购申请人" ellipsis="true" data-index="createByName" />
        <a-table-column key="createTime" title="申请时间" ellipsis="true" data-index="createTime" />
        <a-table-column key="statusAndResult" title="审核状态" ellipsis="true" data-index="statusAndResult">
          <template scope="text,record">
            <span :style="{ color: text == '通过' ? 'green' : '#ffc53d' }">
              {{ text }}
            </span>
          </template>
        </a-table-column>
        <a-table-column key="goodResult" title="采购状态" ellipsis="true" data-index="goodResult" />
        <a-table-column title="详情" width="100px">
          <template scope="text,record">
            <a @click="show_details(record)">详情</a>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <!-- 详情 -->
    <a-modal title="采购查询-详情" :visible="is_details" @cancel="is_details = false" width="90%">
      <template slot="footer">
        <a-button type="primary" @click="is_details = false"> 确定 </a-button>
      </template>
      <a-form-model :model="formInfo" v-if="formInfo != null" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="申请单号">
              {{ formInfo.purchaseCode }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="申请标题">
              {{ formInfo.title }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="申请部门">
              {{ formInfo.deptName }}
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="申请人">
              {{ formInfo.createByName }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="物品名称">
              {{ formInfo.name }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="物品类型">
              {{ goodsTypeObj[formInfo.itemType] }}
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="规格型号">
              {{ formInfo.model }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="申购数量">
              {{ formInfo.amount }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="单位">
              {{ formInfo.unit }}
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="供应商报价均价">
              {{ formInfo.averageQuote }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="申请时间">
              {{ formInfo.createTime }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="期望交付时间">
              {{ formInfo.expectDate }}
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="备注">
              {{ formInfo.remark }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="使用部门">
              {{ formInfo.usagesName }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="采购价">
              {{ formInfo.purchasePrice }}
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="供应商">
              {{ formInfo.supplier }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="采购人">
              {{ formInfo.purchaserName }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="采购时间">
              {{ formInfo.purchaseTime }}
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="支付方式">
              {{ payMap[formInfo.paymentMethod] }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="到货日期">
              {{ formInfo.arrivalDate }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="采购状态">
              {{ formInfo.goodResult }}
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="付款人">
              {{ formInfo.payer }}
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="付款时间">
              {{ formInfo.payTime }}
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-bottom: 15px"><span class="form_title">审批流程</span></a-row>
        <a-row>
          <div class="stpe_box">
            <div class="stpe_item" v-for="(item, index) in stpes" :key="index">
              <div class="center">
                <div class="center_val" :style="{ background: item.flag ? color : '' }">
                  <div class="item" :style="{ color: item.flag ? '#fff' : '' }">{{ item.name }}</div>
                  <div class="item minItem" :style="{ color: item.flag ? '#fff' : '' }">{{ item.auditor }}</div>

                  <div class="item minItem" :style="{ color: item.flag ? '#fff' : '' }">{{ item.endTime }}</div>
                  <div class="records" v-for="(user, idx) in item.records" :key="idx">
                    <div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">
                      {{ user.source }}转交至{{ user.target }}
                    </div>
                    <div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">{{ user.createTime }}</div>
                    <div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">{{ user.reason }}</div>
                  </div>
                </div>
              </div>
              <div class="stepRound" :style="{ background: item.flag ? color : '' }"></div>
              <div
                class="stepLine"
                :style="{ background: item.flag ? color : '' }"
                v-if="index != stpes.length - 1"
              ></div>
            </div>
          </div>
        </a-row>
        <a-row style="margin-bottom: 15px"><span class="form_title">采购流程</span></a-row>
        <a-row>
          <div class="stpe_box">
            <div class="stpe_item" v-for="(item, index) in purchs" :key="index">
              <div class="center">
                <div class="center_val" :style="{ background: item.id ? '#5B8FF9' : '' }">
                  <div class="item" :style="{ color: item.id ? '#fff' : '' }">{{ item.link }}</div>
                  <div class="item minItem" :style="{ color: item.id ? '#fff' : '' }">{{ item.userName }}</div>
                  <div class="item minItem" :style="{ color: item.id ? '#fff' : '' }">{{ item.createTime }}</div>
                  <div class="item minItem" :style="{ color: item.id ? '#fff' : '' }" v-if="item.users != null">
                    被移交人：
                  </div>
                  <div
                    class="item minItem"
                    :style="{ color: item.id ? '#fff' : '' }"
                    v-if="item.users != null"
                    v-for="(item1, index) in item.users"
                    :key="index"
                  >
                    <div class="item minItem" :style="{ color: item.id ? '#fff' : '' }">{{ item.users[index] }}</div>
                  </div>

                  <!-- <div class="item minItem" style="color: #fff;" v-if="item.users != null">{{ item.users[0] }}</div> -->

                  <!-- <div class="records" v-for="(user, idx) in item.records" :key="idx">
										<div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">
											{{ user.source }}转交至{{ user.target }}
										</div>
										<div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">{{ user.createTime }}</div>
										<div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">{{ user.reason }}</div>
									</div> -->
                </div>
              </div>
              <div class="stepRound" style="background-color: #5b8ff9"></div>
              <div class="stepLine" style="background-color: #5b8ff9" v-if="index != purchs.length - 1"></div>
            </div>
          </div>
        </a-row>
        <a-row style="margin-bottom: 15px"><span class="form_title">供应商报价</span></a-row>
        <a-row>
          <a-table :data-source="supplierList" bordered :pagination="false">
            <a-table-column key="index" title="序号" data-index="index">
              <template scope="text, record, index">{{ index + 1 }}</template>
            </a-table-column>
            <a-table-column key="supplierName" ellipsis="true" title="供应商名称" data-index="supplierName">
            </a-table-column>
            <a-table-column key="quote" ellipsis="true" title="报价（单价）" data-index="quote"></a-table-column>
            <a-table-column key="remark" ellipsis="true" title="备注" data-index="remark"></a-table-column>
          </a-table>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { limitCompany } from '@/utils/limitCompany'
import { purchase_apply_quote } from '@/api/activiti'
import { get_process_all } from '@/api/activiti'
import { selectGoodsListAll, goods_record, tree_all } from '@/api/purchase'
import { getDeptListEnable2 } from '@/api/system'
export default {
  data() {
    return {
	companylist: [],
      capital: [
        {
          link: '待采购',
        },
        {
          link: '已下单',
        },
        {
          link: '已到货',
        },
        {
          link: '已验收',
        },
        {
          link: '已入库',
        },
      ],
      accrued: [
        {
          link: '待采购',
        },
        {
          link: '已下单',
        },
        {
          link: '已到货',
        },
        {
          link: '已验收',
        },
        {
          link: '已入库',
        },
        {
          link: '已移交',
        },
      ],
      supplierList: [],
      stpes: [],
      purchs: [],
      serchInfo: {
        purchaseCode: '',
        createBy: '',
        status: undefined,
        buStatus: undefined,
        company_id: undefined,
        deptId: undefined,
        createTimelist: [],
        name: '',
      },
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 16,
      },
      deptTree: [],
      scroll_y: 150,
      loading: false,
      lis: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      is_details: false,
      formInfo: null,
    }
  },
  mounted() {
    this.get_list()
    limitCompany().then((res) => {
      res.forEach((item) => {
        if (item.deptId) {
          this.companylist.push(item)
        }
      })
	  console.log(this.companylist, 'this.companylist================================')
    })
    // tree_all().then((res) => {
    // 	this.companylist = res.data[0]
    // 	this.companylist.unshift({
    // 		deptId: 0,
    // 		title: '所有公司',
    // 		children: [],
    // 	})
    // })
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 120
      }, 1000)
    })
  },
  methods: {
    //
    //切换公司
    handlecompany(value) {
      this.deptTree = []
      this.deptlist = []
      this.serchInfo.deptId = undefined
	  this.companylist.forEach(item => {
		  if(item.deptId == value){
			  this.deptTree = item.children

		  }
	  })
    //   this.$nextTick(() => {
    //     getDeptListEnable2().then((res) => {
    //       const data = res.rows
    //       if (data.length > 0) {
    //         const min = Math.min(...data.map((m) => m.parentId))
    //         this.buildtree2(data, this.deptTree, this.serchInfo.company_id)
    //       }
    //     })
    //   })
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    //获取列表
    get_list() {
      selectGoodsListAll({
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        purchaseCode: this.serchInfo.purchaseCode,
        createBy: this.serchInfo.createBy,
        deptId: this.serchInfo.deptId,
        ancestors: this.serchInfo.company_id,
        buStatus: this.serchInfo.buStatus,
        status: this.serchInfo.status,
        name: this.serchInfo.name,
        createTime1: this.serchInfo.createTimelist.length ? this.serchInfo.createTimelist[0] : '',
        createTime2: this.serchInfo.createTimelist.length ? this.serchInfo.createTimelist[1] : '',
      }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          var lis = res.rows
          // lis.forEach((element) => {
          // 	element['amount'] = element.amount / 100
          // 	element['price'] = element.price / 100
          // 	element['singlePrice'] = element.singlePrice / 100
          // 	element['purchasePrice'] = element.purchasePrice / 100
          // })
          this.lis = res.rows
          const pagination = {
            ...this.pagination,
          }
          pagination.total = res.total
          this.pagination = pagination
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    //重置
    reset() {
      this.serchInfo = {
        purchaseCode: '',
        createBy: '',
        status: undefined,
        buStatus: undefined,
        company_id: undefined,
        deptId: undefined,
        createTimelist: [],
      }
    },
    //搜索
    serch_get_lis() {
      this.loading = true
      this.pagination.current = 1
      this.get_list()
    },
    //改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loading = true
      this.get_list()
    },
    // 详情
    show_details(row) {
      //获得供应商列表
      purchase_apply_quote(row.goodsId).then((res) => {
        if (res.code == 200) {
          this.supplierList = res.data.list
        } else {
          this.$message.error(res.msg)
        }
      })
      this.formInfo = row
      this.is_details = true

      goods_record(row.goodsId).then((res) => {
        if (row.goodType == 1) {
          // 流动资产
          this.purchs = []
          this.purchs = JSON.parse(JSON.stringify(this.capital))
        } else {
          // 固定资产
          this.purchs = []
          this.purchs = JSON.parse(JSON.stringify(this.accrued))
        }
        var flows = res.data.list
        if (flows.length) {
          for (var i = 0; i < flows.length; i++) {
            this.purchs[i] = flows[i]
          }
        }
      })
      get_process_all({
        procInstId: row.procInstId,
        name: 'purchase',
        userId: this.$store.getters.userId,
      }).then((res) => {
        this.commentCount = res.data.commentCount
        this.commentList = res.data.commentList
        var flows = res.data.tasks
        var result = 0
        for (let i = 0, l = flows.length; i < l; i++) {
          if (i + 1 < flows.length) {
            if (flows[i + 1].flag) {
              flows[i]['is_line'] = true
            }
          }
          if (flows[i].result == 3) {
            result = 3
          } else if (flows[i].result == 2) {
            result = 2
          } else if (flows[i].result == 4) {
            result = 4
          }
        }
        flows.forEach((item) => {
          item['result'] = result
        })
        if (result == 3) {
          this.color = '#F56C6C'
        } else if (result == 2) {
          this.color = '#5B8FF9'
        } else if (result == 4) {
          this.color = '#CCCCCC'
        } else {
          this.color = '#5B8FF9'
        }
        this.stpes = flows
      })
    },
  },
}
</script>
<style scoped lang='less'>
.ant-table td {
  white-space: nowrap;
}

.form_title {
  margin-left: 15px;
  margin-bottom: 15px;
  font-size: 17px;
  color: #999;
}

.stpe_box {
  width: 100%;
  float: left;
  margin-bottom: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 50px;

  .stpe_item {
    float: left;
    width: 100%;
    max-width: 300px;
    position: relative;

    .center {
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      max-width: 300px;
      float: left;

      .center_val {
        width: 100%;
        max-width: 300px;
        border-radius: 8px;
        float: left;
        padding: 5px 8px;
        box-sizing: border-box;
        background: #eee;
        min-height: 72px;
      }

      .item {
        width: 100%;
        float: left;
      }

      .minItem {
        font-size: 13px;
      }

      .records {
        width: 100%;
        float: left;
        font-size: 13px;
        margin-top: 10px;

        .recordsTop {
          width: 100%;
          float: left;
        }
      }
    }

    .arrow {
      width: 50px;
      float: left;
      font-size: 18px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .stepRound {
      position: absolute;
      left: 50%;
      top: -30px;
      width: 24px;
      height: 24px;
      background: #999;
      border-radius: 50%;
      transform: translateX(-50%);
      z-index: 5;
    }

    .stepLine {
      position: absolute;
      left: 50%;
      top: -20px;
      width: 100%;
      height: 2px;
      background: #eee;
    }
  }
}
</style>
